// import css
import './sass/style.min.css';
// React Rounterのimport
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
// import pages
import {PageKondou, PageNews, PageArticle, PageProduct, PageCompanyStory, PageNone} from './components'
import {PageNewsTabs, PageCompany, PageContact, PagePrivacyPolicy, PageConfirm} from './components'
import ScrollTop from './components/ScrollTop';

function App() {  
  const location = useLocation()

  return (
    <div className="App">
      {/*URLの切り替え*/}
      <AnimatePresence>
        {/* <Router basename="/build/">  */}
        {/* <Router> */}
          <ScrollTop />
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageKondou />} />
            <Route path="/company" element={<PageCompany />} />
            <Route path="/story" element={<PageCompanyStory />} />
            <Route path="/news" element={<PageNews />} />
            <Route path="/article" element={<PageArticle />} />
            <Route path="/product" element={<PageProduct />} />
            <Route path="/news-tabs" element={<PageNewsTabs />} />
            <Route path="/contact" element={<PageContact />} />
            <Route path="/privacypolicy" element={<PagePrivacyPolicy />} />
            <Route path="/*" element={<PageNone/>} />
          </Routes>
        {/* </Router>  */}
      </AnimatePresence>
    </div>
  );
}

export default App;
